// @flow

import type {ConfigFunction as MarkdocFunctionSchema} from '@markdoc/markdoc';

export const country: MarkdocFunctionSchema = {
  render(parameters, config): boolean {
    const countryValue = (config?.variables?.intl: any)?.country ?? 'US';
    return Object.values(parameters).includes(countryValue);
  },
};
